import React from "react";
import './gradientheader.css'

export function GradientHeaderComponent({className, title, tagline, children}) {
    return (<div className={className}>
        <h1 className="h1Gradient">{title}</h1>
        {tagline && <p className="tagline big">{tagline}</p>}
        {children && <div className="paragraphs withTopMargin">
            {children}
        </div>}
    </div>);
}
